import { render } from "./ClassDiary.vue?vue&type=template&id=290b27c1&ts=true"
import script from "./ClassDiary.vue?vue&type=script&lang=ts"
export * from "./ClassDiary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__